import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, ButtonToolbar, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import TagsInput from 'react-tagsinput';
import keyCodes from '../../keyCodes';

import CancelModal from '../CancelModal.jsx';

import '../css/form.css';

class FinishingInfoForm extends Component {
  constructor(props) {
    super();

    this.state = {
      links: { status: null, error: '' },
      disableNextButton: false,
      showCancelConfirm: false,
      inputStyle: {
        placeholder: 'Esim. poliisi, ensihoito, liikenneonnettomuus'
      }
    };

    this.createLinkComponent = this.createLinkComponent.bind(this);
  }

  componentDidMount() {
    this.changePlaceholder(0);
  }

  handleChange = (e) => {
    this.props.handleChange(e.target.name, e.target.value);
    this.setState(this.props.displayError(e.target.name));
  }

  handleTagChange = (input) => {
    this.setState({ input }, () => { this.changePlaceholder(input); });
    this.props.handleChange('keywords', input);
  }

  changePlaceholder(tags) {
    const newInputStyle = this.state.inputStyle;
    if (tags.length === 0) {
      newInputStyle.placeholder = 'Esim. poliisi, ensihoito, liikenneonnettomuus';
      this.setState({ inputStyle: newInputStyle });
    } else {
      newInputStyle.placeholder = '';
      this.setState({ inputStyle: newInputStyle });
    }
  }

  handleMissingHttp = (index, e) => {
    if (e.target.value.indexOf('http') === -1 && e.target.value.length > 0) {
      const newlinks = this.props.state.formData.links;
      newlinks[index].url = `http://${e.target.value}`;
    }
    this.handleChange(e);
  }

  handleUrlChange = (index, e) => {
    const newLinks = this.props.state.formData.links;
    newLinks[index][e.target.name] = e.target.value;
    this.props.handleChange('links', newLinks);
    this.setState(this.props.displayError('links'));
  }

  addUrlField = () => {
    const newLinks = this.props.state.formData.links;
    newLinks.push({ url: '', text: '' });
    this.props.handleChange('links', newLinks);
  }

  removeField = (index) => {
    const newLinks = this.props.state.formData.links;
    newLinks.splice(index, 1);
    this.props.handleChange('links', newLinks);
  }

  checkValidationErrors = () => {
    const state = this.props.checkValidationErrors(this.state);
    this.setState({ state });
  }

  createLinkComponent(field, index) {
    return (
      <Form key={index}>
        <FormControl
          name="url"
          value={this.props.state.formData.links[index].url}
          placeholder="Linkin URL-osoite"
          type="text"
          onBlur={e => this.handleMissingHttp(index, e)}
          onChange={e => this.handleUrlChange(index, e)}
        />
        {' '}
        <FormControl
          name="text"
          value={this.props.state.formData.links[index].text}
          placeholder="Linkin selite"
          type="textarea"
          onChange={e => this.handleUrlChange(index, e)}
        />
        {' '}
        <Button bsStyle="warning" bsSize="small" onClick={() => this.removeField(index)}>Poista</Button>
        {' '}
      </Form>
    );
  }

  render() {
    return (
      <form>
        <FormGroup validationState={this.state.links.status}>
          <br />
          <ControlLabel>Lisätietolinkit</ControlLabel>
          {' '}
          <Form componentClass="fieldset" inline>
            { this.props.state.formData.links.map(this.createLinkComponent) }
          </Form>
          <HelpBlock>{this.state.links.error}</HelpBlock>
        </FormGroup>

        <Button bsStyle="primary" bsSize="small" onClick={this.addUrlField}>Uusi linkki</Button>

        <FormGroup>
          <br />
          <ControlLabel>Asiasanat (avainsana lisätään painamalla välilyöntiä)</ControlLabel>
          <TagsInput
            className="react-tagsinput formTagsInput"
            inputProps={this.state.inputStyle}
            addKeys={[keyCodes.enter, keyCodes.space]}
            value={this.props.state.formData.keywords || []}
            onChange={this.handleTagChange}
          />
        </FormGroup>

        <ButtonToolbar>
          <br />
          <Button bsStyle="primary" onClick={this.props.previousPage}>Edellinen</Button>
          <Button bsStyle="primary" onClick={this.checkValidationErrors} disabled={this.state.disableNextButton}>
            Julkaise
          </Button>
          <Button onClick={() => this.setState({ showCancelConfirm: true })} >Keskeytä</Button>

          <CancelModal
            show={this.state.showCancelConfirm}
            handleCancel={this.props.handleCancel}
            disableCancelConfirm={() => this.setState({ showCancelConfirm: false })}
          />
        </ButtonToolbar>
      </form>
    );
  }
}

FinishingInfoForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  displayError: PropTypes.func.isRequired,
  checkValidationErrors: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired
};

export default FinishingInfoForm;



// WEBPACK FOOTER //
// ./src/components/forms/FinishingInfoForm.jsx